// src/hooks/useUserActions.ts
import { useNavigate } from 'react-router-dom';
import { useJwt } from 'react-jwt';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { URL_SERVER } from '../utils/Utils';
import { TokenPayload } from '../utils/Types';

const useUserActions = () => {
  const navigate = useNavigate();

  const storageToken = secureLocalStorage.getItem("token");
  const token = typeof storageToken === "string" ? storageToken : null;
  const { decodedToken } = useJwt<TokenPayload>(token ?? '');

  const handlePasswordChange = async () => {
  /*  console.log("CLICK");
    console.log("TOKEN:", token);
    console.log("USER ID:", decodedToken?.id); */
    if (!token || !decodedToken?.id) {
      alert("Sesión inválida");
      return;
    }

    try {
      await axios.post(
        `${URL_SERVER}/v2/users/${decodedToken.id}/request-password-change`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Revisa tu correo para confirmar el cambio de contraseña");

    } catch (error) {
      console.error("Error:", error);
      alert("Error al solicitar el cambio de contraseña");
    }
  };

  const handleLogout = () => {
    secureLocalStorage.clear();
    navigate('/');
  };

  return {
    decodedToken,
    handlePasswordChange,
    handleLogout,
  };
};

export default useUserActions;